import { render, staticRenderFns } from "./Mantenimiento.vue?vue&type=template&id=536cedd8&scoped=true&"
import script from "./Mantenimiento.vue?vue&type=script&lang=js&"
export * from "./Mantenimiento.vue?vue&type=script&lang=js&"
import style0 from "./Mantenimiento.vue?vue&type=style&index=0&id=536cedd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536cedd8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
